module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0050.jpg?v=5e7f851c";